export default {
    url: '',
    template: '<manage-templates-list/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/templates/list/index.js